<template>
  <div>
    <DateIntervalPicker
      v-model="interval"
      class="mb-3">
    </DateIntervalPicker>
    <v-card-title>
      {{ $t('profile.purchases.title') }}
    </v-card-title>
    <purchase-table
      :page="page"
      :adminId="expert.id"
      :period="interval"
      periodFilter="payed_at"
      scope="finished_with_cash_received_or_failed"
      @filterUpdated="data => onFilterUpdated(data)">
    </purchase-table>
  </div>
</template>

<script>
  import Utils from '@/utils/default'
  import withInterval from '@/mixins/withInterval'
  import PurchaseTable from '@/components/purchase/Table.vue'
  import expert from '@/mixins/expert'
  export default {
    mixins: [
      expert,
      withInterval
    ],
    components: {
      PurchaseTable
    },
    props: {
      page: {
        type: Number,
        default: 1
      }
    },
    methods: {
      onFilterUpdated (filter) {
        this.$router.push({
          ...this.$route,
          query: Utils.dataForUrl(filter)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/expert/Purchases.vue